export default function validation(response, messages) {
  if (!response?.data?.error?.validationErrors) return;
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('LIGNE_COMMANDE_LINK_TO_AN_OT') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'validationCommande.ligneCommandeLinkToAnOT',
        parametres: {
          libelle: elements[1],
        },
      });
    }
  });
}
